/*@flow*/
import type { Map, RecordInstance, List } from 'immutable';
type StateT = Map<*, *> | List<*> | RecordInstance<*>;
type PathT = string | any[];

export type PayloadT = {
  path: PathT,
  value: any,
};

type SetFnT = (o: PayloadT) => any;

const createUpdater = (v) => (...args) =>
  typeof v === 'function' ? v(...args) : v;

// Usage:
//    setIn(state)({ path: 'app.tasks', value: (v) => v.set('done', true)})
export default (state: StateT): SetFnT => (props: PayloadT) => {
  const { path, value } = props;
  const updater = createUpdater(value);

  // Verify path if path is non-empty string.
  if (!path) return updater(state);

  // Split it into array using dot.
  const newPath = typeof path === 'string' ? path.split('.') : path;

  // $FlowFixMe[incompatible-call]
  return state.updateIn(newPath, updater);
};
